<template>
  <div class="content">
    <div class="main">
      <Row>
      <Col span="5"></Col>
      <Col span="24" :md="12">
        <Form ref="formItem" :model="formItem" :label-width="100" :rules="ruleValidate">
          <FormItem  label="部署服务" prop="server">
            <Input   v-model="formItem.server"></Input>
          </FormItem>
          <form-item label="Jenkins Job" prop="jenkins_job">
              <Input   v-model="formItem.jenkins_job"></Input>
          </form-item>
          <form-item label="数据库服务" prop="server_db">
              <Input   v-model="formItem.server_db"></Input>
          </form-item>
          <form-item label="服务器类型" prop="server_type" >
             <i-select v-model="formItem.server_type">
                  <Option value="pod">pod</Option>
                  <Option value="docker">docker</Option>
                  <Option value='physical'>Physical</Option>
             </i-select>
          </form-item>
          <FormItem  label="内网地址" prop="address_in">
            <Input   v-model="formItem.address_in"></Input>
          </FormItem>
          <FormItem  label="外网地址" prop="address_ex">
            <Input   v-model="formItem.address_ex"></Input>
          </FormItem>
          <form-item label="数据库" prop="databases" >
             <i-select v-model="formItem.databases" multiple>
                  <Option value="测试数据库实例1">测试数据库实例1</Option>
                  <Option value="测试数据库实例2">测试数据库实例2</Option>
             </i-select>
          </form-item>
        <FormItem>
            <Button type="primary" @click="doSubmit('formItem')">修改</Button>
        </FormItem>
    </Form>
    </Col>
    </Row>
</div></div>
</template>
<script>
import { ProjectDeploymentSubmit, fetchDeploymentData } from '@/api/project'
export default {
  name: 'DeploymentForm',
  components: {
  },
  props:
    {
      'id': Number,
      'scenes': {
        type: String,
        required: true
      }
    },
  data () {
    return {
      id_own: null,
      // scenes_own: null,
      formItem: {
        server: '',
        jenkins_job: '',
        server_db: '',
        server_type: '',
        address_in: '',
        address_ex: '',
        databases: []
      },
      ruleValidate: {
        // group: [{ required: true, message: '项目所在组不能为空 !', trigger: 'blur' }],
        // host: [{ required: true, message: '代码服务器不能为空 !', trigger: 'blur' }]
      }
    }
  },
  watch: {
    // scenes () {
    //   this.scenes_own = this.scenes
    // },
    id () {
      this.id_own = this.id
      // 取Code info
      if (this.id_own) {
        this.fetchDeploymentData(this.id_own, this.scenes)
      }
    }
  },
  methods: {
    doSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.formItem['databases'] = this.formItem['databases'].join(',')
          ProjectDeploymentSubmit(this.$route.query.id, this.formItem, this.scenes).then(res => {
            if (res.data.id > 0) {
              this.$router.push({name: 'ProjectDetail', query: {id: this.id_own}})
            } else {
              this.$Message.error(res.data)
            }
          })
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
      })
    },
    fetchDeploymentData (id, scenes) {
      fetchDeploymentData(id, scenes).then(res => {
        this.formItem.server = res.data.server
        this.formItem.jenkins_job = res.data.jenkins_job
        this.formItem.server_db = res.data.server_db
        this.formItem.server_type = res.data.server_type
        this.formItem.address_in = res.data.address_in
        this.formItem.address_ex = res.data.address_ex
        this.formItem.databases = res.data.databases
      })
    }
  },
  mounted: function () {
  }
}
</script>
